import { BrandConfig, BrandConfigSourceType } from '@low/dynamic/types';

export const BRAND_CONFIG_REDUCER_TYPE = {
    UPDATE_FROM_LOCAL: 'UPDATE_FROM_LOCAL',
    UPDATE_FROM_CACHE: 'UPDATE_FROM_CACHE',
    UPDATE_FROM_BSS_FALLBACK: 'UPDATE_FROM_BSS_FALLBACK',
    UPDATE_FROM_BSS: 'UPDATE_FROM_BSS',
};
export function brandConfigReducer(state: BrandConfig, { type, payload }) {
    switch (type) {
        case BRAND_CONFIG_REDUCER_TYPE.UPDATE_FROM_LOCAL:
            return {
                ...state,
                ...payload,
                source: BrandConfigSourceType.LOCAL,
            };
        case BRAND_CONFIG_REDUCER_TYPE.UPDATE_FROM_CACHE:
            return {
                ...state,
                ...payload,
                source: BrandConfigSourceType.CACHE,
            };
        case BRAND_CONFIG_REDUCER_TYPE.UPDATE_FROM_BSS_FALLBACK:
            return {
                ...state,
                ...payload,
                source: BrandConfigSourceType.BSS_FALLBACK,
            };
        case BRAND_CONFIG_REDUCER_TYPE.UPDATE_FROM_BSS:
            return {
                ...state,
                ...payload,
                source: BrandConfigSourceType.BSS,
            };
        default:
            return state;
    }
}
